import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { Edit, Trash, More } from "@rsuite/icons";
import React, { useState } from "react";
import { IconButton } from "rsuite";
import { useTranslation } from "react-i18next";
import Followup from "./Followup";

const FollowupSingleAction = ({
  followupData,
  onDeleteFollowup,
  onFollowup,
  ...props
}: {
  followupData: any;
  onDeleteFollowup: Function;
  onFollowup?: Function;
}) => {
  const { t } = useTranslation();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const handleEvent = (eventKey: any) => {
    setOpenModalByName(eventKey);
  };

  return (
    <div>
      <>
        <IconButton
          appearance="subtle"
          onClick={() => {
            if (+followupData.follow_up_id > 0) handleEvent("manage-follow-up");
          }}
          title={t("EDIT")}
          icon={<Edit />}
        />
      </>
      {UtilityServices.hasPermissionOnFollowup(followupData) && (
        <>
          <IconButton
            onClick={() => {
              setOpenDeleteModal(true);
            }}
            icon={<Trash />}
            title={t("DELETE")}
            size="md"
          />
        </>
      )}
      {openModalByName === "manage-follow-up" && (
        <Followup
          openModal={openModalByName === "manage-follow-up" ? true : false}
          setOpenModal={setOpenModalByName}
          rowData={followupData}
          onFollowup={onFollowup}
          followupId={followupData?.follow_up_id}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteFollowup(followupData);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("FOLLOWUP").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
    </div>
  );
};

export default FollowupSingleAction;
